import ButtonWithIcon from './ButtonWithIcon';

function install(Vue) {
  Vue.component('icon-button', ButtonWithIcon);
}

export default { install };
